const cashfreeMode = 'production'; //for testing use 'sandbox' for live use 'production'

export const environment = {
  production: true,
  URL: 'https://manager.daaisuite.click/daaisaas/',
  cashfreeMode: cashfreeMode,
  // Cloudflare Turnstile site key (PUBLIC). Empty = widget disabled, signup
  // works as before. Set this to the prod site key from the Cloudflare dashboard
  // to enable the bot check; pair with TURNSTILE_SECRET_KEY + CAPTCHA_MODE=enforce
  // on the server.
  turnstileSiteKey: '',
};